import { shallowMount } from "@vue/test-utils";
import CountrySelector from "@/components/core/composite/combos/CountrySelector";

describe("CountrySelector component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(CountrySelector);
  });

  it("Renders del component CountrySelector", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
